export const getTotalFiles = (zakazes) => {
	return zakazes.reduce((acc, zakaz) => {
		// const fileUrl = zakaz.file_url?.length ?? 0;
		const photoUrl = zakaz.photo_url?.length ?? 0;
		const total = photoUrl;
		return acc + total;
	}, 0);
};
